import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Router } from 'react-router';
import { createBrowserHistory } from 'history';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const history = createBrowserHistory({
  basename: '/refinitiv'
})

const routing = (
  <Router history={history} basename={'/refinitiv'}>
    <div>
      <Route exact path={`/`} component={App} />
    </div>
  </Router>
)

ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
